import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const MaterialProcessPage = lazy(() =>
  import('@/pages/ads/material-process/material-process-page').then((m) => ({
    default: m.MaterialProcessPage,
  })),
);

export const Route = createFileRoute('/_app/ads/material-process/')({
  component: () => (
    <Suspense fallback={<div>加载中…</div>}>
      <MaterialProcessPage />
    </Suspense>
  ),
});
